var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 85.337,
    fill: "#FFFFFF",
    width: 512,
    height: 341.326
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 85.337,
    fill: "#A2001D",
    width: 512,
    height: 113.775
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 312.888,
    fill: "#0052B4",
    width: 512,
    height: 113.775
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNl);
export default __webpack_public_path__ + "static/media/nl.2a548c3111d20d302bebae8776ab2e3d.svg";
export { ForwardRef as ReactComponent };